<template>
  <div>
    <div class="all-available-services__filter">
      <label class="input">
        <input :placeholder="getLocalization('Search by service')" v-model="searchServices"/>
        <img src="/img/svg/common/search-black.svg" alt=""/>
      </label>
    </div>
    <div class="all-available-services__grid">
      <template v-for="service in searchList">
        <a :href="servicesRoute + '/' + service['slug']" style="text-decoration: none">
          <div class="card-service" itemscope itemtype="http://schema.org/ImageObject">
            <img :src="service['img_path']" class="card-service__image" :alt="service['title']"/>
            <span class="card-service__name" itemprop="name">{{getLocalization(service['title'])}}</span>
          </div>
        </a>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "popularActivationsService",
  props: [
    'services',
    'servicesRoute',
  ],
  data() {
    return {
      allServices: [],
      searchServices: ''
    }
  },
  mounted() {
    this.allServices = this.services;
  },
  computed: {
    searchList() {
      if (!this.searchServices) {
        return [...this.allServices]
      }

      const searchServices = (this.searchServices || '').trim().toLowerCase();
      return this.allServices.filter(service => service.title && service.title.toLowerCase().includes(searchServices));
    }
  }
}
</script>
